export class VideoStreamingTime {
  constructor(
    public videoStreaming: boolean, // ビデオ配信設定。true:ビデオ配信ON, false: ビデオ配信OFF
    public dateTime: string, // ビデオ配信ON/OFFを切り替えた日時
  ) {}
}
